import styled from '@mui/material/styles/styled';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';

export const Root = styled('div', { shouldForwardProp: (prop) => prop !== 'sender' }
)(({ sender }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: (sender === 'bot' || sender === 'system') ? 'center' : sender === 'manager' ? 'flex-end' : 'flex-start',
}));

export const Wrapper = styled('div', { shouldForwardProp: (prop) => prop !== 'sender' }
)(({ sender }) => ({
  maxWidth: (sender === 'bot' || sender === 'system') ? '100%' :'80%',
  width: (sender === 'bot' || sender === 'system') ? '100%' :'auto',
  display: 'flex',
  flexDirection: sender === 'manager' ? 'row-reverse' : (sender === 'bot' || sender === 'system') ? 'column' : 'row',
  alignItems: (sender === 'bot' || sender === 'system') ? 'center' : 'flex-end',
  gap: '8px',
  marginLeft: sender === 'patient' ? '34px' : 'unset',
}));

export const Paper = styled('div', { shouldForwardProp: (prop) => prop !== 'sender' }
)(({ theme, sender }) => ({
  flexGrow: 1,
  width: (sender === 'bot' || sender === 'system') ? '100%' : 'auto',
  backgroundColor: sender === 'manager' ? theme.palette.primary.main : sender === 'patient' ? theme.palette.background.paper : 'transparent',
  borderRadius: sender === 'patient' ? '8px 8px 8px 0px' : '8px 8px 0px 8px',
  border: (sender === 'bot' || sender === 'system') ? '1px solid #338f9d' : 'none',
  padding: (sender === 'bot' || sender === 'system') ? '6px' : '12px',
}));

export const Text = styled((props) => (
  <Typography variant='caption' whiteSpace='pre-line' component='div' {...props} /> ),
  { shouldForwardProp: (prop) => prop !== 'sender' }
)(({ theme, sender }) => ({
  color: (sender === 'bot' || sender === 'system') ? theme.palette.primary.dark : sender === 'manager' ? theme.palette.text.hint : theme.palette.text.primary,
  fontSize: (sender === 'bot' || sender === 'system') ? '12px' :'14px'
}));

export const Channel = styled((props) => <Typography variant='caption' textTransform='uppercase' component='div' {...props} />, { shouldForwardProp: (prop) => prop !== 'sender' }
)(({ theme, sender }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: sender === 'manager' ? 'flex-end' : 'flex-start',
  color: (sender === 'bot' || sender === 'system') ? theme.palette.primary.dark : sender === 'manager' ? theme.palette.text.hint : theme.palette.text.primary,
  marginTop: 8,
  fontWeight: 700,
  fontSize: '10px'
}));

export const Time = styled((props) => (
  <Typography variant='caption' component='div' {...props} /> ),
{ shouldForwardProp: (prop) => prop !== 'sender' }
)(({ sender }) => ({
  flexShrink: 0,
  ...((sender === 'bot' || sender === 'system') && {
    display: 'flex',
    width: '100%',
    alignItems: 'flex-end',
    justifyContent: 'flex-end'
  })
}));

export const Actions = styled('div',
  { shouldForwardProp: (prop) => prop !== 'sender' }
)(({ sender }) => ({
  flexShrink: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '2px',
  ...((sender === 'bot' || sender === 'system') && {
    width: '100%',
    alignItems: 'baseline',
    justifyContent: 'flex-end',
    flexDirection: 'column',
    gap: '8px'
  })
}));

export const Info = styled('div')(({ theme }) => ({
  '& > *': {
    color: `${theme.palette.primary.main} !important`,
  }
}));

export const Rejected = styled('div')({
  display: 'flex',
  width: '100%',
  alignItems: 'flex-end',
  justifyContent: 'flex-end',
  '& > *': {
    color: '#E30000 !important',
    fontWeight: '600 !important',
  }
});

export const Approve = styled('div')({
  display: 'flex',
  gap: 8
});

export const MenuButton = styled(IconButton)({
  width: 24,
  height: 24,
  fontSize: 12,
  padding: 0,
  '& > svg': {
    width: 20,
    height: 20,
  }
});

export const Img = styled('img')(() => ({
  width: 180,
  height: 'auto',
  objectFit: 'cover',
  borderRadius: '6px',
  marginTop: 12
}));

